import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import MyDropdownButton from "../Common/MyDropdownButton";
import MyIcon from "../Common/MyIcon";
import HelpButton from "../HelpContent/HelpButton";
import AiIcon from "../../assets/icons/Icon_Library/application icons/library/boomAI_icon.svg2";

export default function AiDropdown({
  aiType,
  setAiType,
  spellingErrors,
  isOnline,
}) {
  const aiTypesOptions = [
    {
      label: "Spelling Recommendations",
      heading: "Spelling",
      icon: AiIcon,
      info: "Uses AI to provide spelling recommendations.",
      badge: spellingErrors || null,
      isDisabled: false,
    },
    {
      label: "Content-Grammar Recommendations",
      heading: "Content-Grammar",
      icon: AiIcon,
      info: "Uses AI to provide content-grammar recommendations.",
      badge: null,
      isDisabled: false,
    },
    {
      label: "Change the language",
      heading: "Language",
      icon: AiIcon,
      info: "Uses AI to translate text into another language.",
      isDisabled: true,
    },
  ];

  return isOnline ? (
    <div className="">
      <Dropdown>
        <div className="d-flex">
          <Dropdown.Toggle
            id="ai-dropdown-toggle"
            className="bg-transparent p-0 d-flex align-items-center border-0"
            disabled={!isOnline}
            title="Please select your AI options"
          >
            <div className="fw-bold text-start align-items-center d-flex position-relative">
              <MyIcon Icon={AiIcon} width={25} />
              {!!spellingErrors && (
                <span className="badge bg-colored text-white rounded-pill mt-n3 ms-n1">
                  {spellingErrors}
                </span>
              )}
              <HelpButton helpKey="ai-modal" />
            </div>
          </Dropdown.Toggle>
        </div>

        <Dropdown.Menu className="bg-purple-gradient">
          <div className="p-2 px-3 text-navy fw-bold">
            How would you like AI to assist you?
          </div>
          {aiTypesOptions?.map((o) => (
            <Dropdown.Item className="border-bottom" as="div" key={o.label}>
              <button
                type="button"
                className={`btn p-0 w-100 `}
                onClick={(e) => {
                  setAiType(o);
                }}
              >
                <div className="d-flex  ">
                  <div className="me-3">{o.icon && <o.icon width={25} />}</div>
                  <div className="text-start text-nowrap position-relative">
                    <div className="fw-bold">
                      {o.label}{" "}
                      <span className="ms-2 badge bg-colored text-white position-absolute ">
                        {o.badge}
                      </span>
                    </div>
                    <div className="small text-secondary">{o.info}</div>
                  </div>
                </div>
              </button>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  ) : (
    <span
      className="fw-bold text-start align-items-center d-flex position-relative opacity-50"
      title="You are currently not connected to the AI server. Please check your connection or try again later"
    >
      <MyIcon Icon={AiIcon} width={25} />
      {!!spellingErrors && (
        <span className="badge bg-colored text-white rounded-pill mt-n3 ms-n1">
          {spellingErrors}
        </span>
      )}
      <HelpButton helpKey="ai-modal" />
    </span>
  );
}
